<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar title="Accounts" :icon="require('@/assets/icon/accounts-active.svg')">
        <div class="options">
          <widgetSearch v-model="filter_form.query" class="search-account" placeholder="Search here..." icon="right"
            @keyup="searchContacts">
          </widgetSearch>

          <div class="v-line-divider" style="height: 40px"></div>
          <widgetDropdown v-model="show_filter_widget" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              Filter
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <widgetFilterPopUp>

                <widgetInputWrapper title="Location">
                  <map-helper @onSubmit="onFilterByLocation" v-model="filter_form.location"
                    placeholder="Filter by location" type="account"></map-helper>
                </widgetInputWrapper>

                <widgetInputWrapper title="View">
                  <div class="filter-item">
                    <widgetDropdown v-model="view_input" :right="true" :hover="false" :interactive="true"
                      style="width: 100%;">
                      <button class="btn-dropdown">
                        View
                        <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                      </button>
                      <div slot="dropdown" class="dropdown-widget right">
                        <widgetTableColumnToggle @input="(data) => {
                          setTableColumns(data)
                        }" tableType="contacts" :value="visibleColumns" :availableColumns="availableColumns">
                        </widgetTableColumnToggle>
                      </div>
                    </widgetDropdown>
                  </div>
                </widgetInputWrapper>

                <widgetInputWrapper title="Display">
                  <div class="filter-item">
                    <widgetDropdown v-model="display_input_filter" :right="true" :hover="false" :interactive="true">
                      <button class="btn-dropdown">
                        Display
                        <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                      </button>
                      <div slot="dropdown" class="dropdown-widget right">
                        <a class="dropdown-item" href="#" v-for="(item, index) in display_filter" :key="index"
                          @click="view_type = item.value">
                          {{ item.name }}</a>
                      </div>
                    </widgetDropdown>
                  </div>
                </widgetInputWrapper>

                <widgetInputWrapper title="Tags">
                  <div class="filter-item">
                    <widgetDropdown v-model="tags_input_filter" :right="true" :hover="false" :interactive="true">
                      <button class="btn-dropdown">
                        Tags
                        <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                      </button>
                      <div slot="dropdown" class="dropdown-widget right">
                        <widgetListSelecter v-model="tags_filter" @close="tags_input_filter = false" @confirm="(data) => {
                          tags_input_filter = false;
                          filterByTag(data);
                        }
                        "></widgetListSelecter>
                      </div>
                    </widgetDropdown>
                  </div>
                </widgetInputWrapper>

                <widgetInputWrapper title="Contact Owner">
                  <div class="filter-item">
                    <widgetDropdown v-model="contact_owner_input" :right="true" :hover="false" :interactive="true">
                      <button class="btn-dropdown">
                        Contact Owner
                        <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                      </button>
                      <div slot="dropdown" class="dropdown-widget right">
                        <widgetListSelecter v-model="contact_owner_filter" @close="contact_owner_input = false"
                          @confirm="(data) => {
                            contact_owner_input = false;
                            filterByContactOwner(data);
                          }
                          "></widgetListSelecter>
                      </div>
                    </widgetDropdown>
                  </div>
                </widgetInputWrapper>

                <widgetInputWrapper title="Contact Types">
                  <div class="filter-item">
                    <widgetDropdown v-model="roles_input_filter" :right="true" :hover="false" :interactive="true">
                      <button class="btn-dropdown">
                        Contact Types
                        <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                      </button>
                      <div slot="dropdown" class="dropdown-widget right">
                        <widgetListSelecter v-model="roles_filter" @close="roles_input_filter = false" @confirm="(data) => {
                          roles_input_filter = false;
                          filterByRole(data);
                        }
                        "></widgetListSelecter>
                      </div>
                    </widgetDropdown>
                  </div>
                </widgetInputWrapper>

                <widgetInputWrapper title="Sort Options">
                  <div class="filter-item">
                    <widgetDropdown v-model="sort_input_filter" :right="true" :hover="false" :interactive="true">
                      <button class="btn-dropdown">
                        Sort
                        <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                      </button>
                      <div slot="dropdown" class="dropdown-widget right">
                        <a class="dropdown-item" href="#" v-for="(item, index) in sort_filter" :key="index" @click="() => {
                          if (item.value == 'name') {
                            filterBySort(item.value, 'asc')
                          } else {
                            filterBySort(item.value, 'desc')
                          }
                        }">
                          {{ item.name }}</a>
                      </div>
                    </widgetDropdown>
                  </div>
                </widgetInputWrapper>

                <widgetInputWrapper title="Data">
                  <div class="filter-item">
                    <widgetDropdown v-model="data_input_filter" :right="true" :hover="false" :interactive="true">
                      <button class="btn-dropdown">
                        {{ filter_form.type === 'mine' ? 'My Contacts' : 'All Contacts' }}
                        <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                      </button>
                      <div slot="dropdown" class="dropdown-widget right">
                        <a class="dropdown-item" href="#" v-for="(item, index) in data_filter" :key="index"
                          @click="filterContactByType(item.value)">
                          {{ item.name }}</a>
                      </div>
                    </widgetDropdown>
                  </div>
                </widgetInputWrapper>
              </widgetFilterPopUp>
            </div>
          </widgetDropdown>
          <div class="v-line-divider" style="height: 40px"></div>
          <widgetButton :loading="false" @click="addNew()" class="btn-add btn-secondary">
            Add Contact +
          </widgetButton>
        </div>
      </WidgetToolbar>
    </div>
    <div class="page-tab">
      <widgetTabs :tabs="[
        {
          title: 'Accounts',
          value: 'accounts',
        },
        {
          title: contacts_data ? 'Contacts (' + contacts_data.total + ')' : 'Contacts',
          value: 'account_contacts',
        },
        {
          title: 'LIA Generation',
          value: 'lia_contacts',
        }
      ]" v-model="tab" @change="(type) => {
        $emit('tab', type.value);
      }
      "></widgetTabs>

      <div class="page-tab-options row">
        <widgetButton v-if="show_selected_options" class="btn-primary" :loading="false"
          @click="ExportSelectedContact()">Export Contact</widgetButton>
        <div v-if="show_selected_options" class="h-spacer"></div>
        <widgetButton v-if="show_selected_options" :loading="false" @click="addContactOwnerOnSelected()"
          class="btn-primary">
          Add Contact Owner
        </widgetButton>
        <div v-if="show_selected_options" class="h-spacer"></div>
        <widgetButton v-if="isActiveFilter" class="btn-transparent-secondary fit-content" href="#"
          @click="clearFilter()">
          Clear Filter</widgetButton>
        <div v-if="show_selected_options" class="h-spacer"></div>
        <widgetDropdown v-if="show_selected_options" v-model="selected_list_dropdown" :right="true" :hover="false"
          :interactive="true" class="selected-dropdown">
          <button class="btn-dropdown">
            <img class="icon" style="height: 20px" src="@/assets/icon/menu-dot.svg" />
          </button>
          <div slot="dropdown" class="dropdown-widget right">
            <a class="dropdown-item" href="#" @click="sendEmailSelectedAccount()">Send Email</a>
            <a class="dropdown-item" href="#" @click="DeleteSelectedContacts()">Delete Selected</a>
          </div>
        </widgetDropdown>
      </div>
    </div>
    <div class="page-body">
      <div class="tab-body">
        <div class="left-panel">
          <!-- Table view -->
          <div class="contacts-table" v-if="view_type == 'list'" @scroll="onPageScoll">
            <table class="table-data" v-if="contacts_data && contacts_data.data.length > 0">
              <thead class="table-header">
                <tr>
                  <th>
                    <div class="space-between">
                      <div class="row">
                        <input @change="onSelectAll" class="checkbox" type="checkbox" />
                        <div class="h-spacer"></div>
                        <div>Name</div>
                      </div>
                      <widgetAscDesc v-model="filter_form.sort_type"
                        @click="filterBySort('name', filter_form.sort_type)"></widgetAscDesc>

                    </div>
                  </th>

                  <th v-if="visibleColumns.includes('Account')">
                    <div class="space-between">
                      <div>Account</div>
                      <widgetAscDesc v-model="filter_form.sort_type"
                        @click="filterBySort('account', filter_form.sort_type)"></widgetAscDesc>
                    </div>
                  </th>
                  <th v-if="visibleColumns.includes('Email_Phone')">
                    <div class="space-between">
                      <div>Email & Phone</div>
                      <widgetAscDesc v-model="filter_form.sort_type"
                        @click="filterBySort('email', filter_form.sort_type)"></widgetAscDesc>
                    </div>
                  </th>
                  <th v-if="visibleColumns.includes('Position_Domain')">
                    <div class="space-between">
                      <div class="row">
                        <div>Position & Domain</div>
                      </div>
                    </div>
                  </th>
                  <th v-if="visibleColumns.includes('ContactOwner')">
                    <div class="space-between">
                      <div style="white-space:nowrap">Contact owner</div>
                    </div>
                  </th>
                  <th v-if="visibleColumns.includes('Tags')">Tags</th>
                  <th v-if="visibleColumns.includes('ContactTypes')">Contact Types</th>
                  <th v-if="visibleColumns.includes('School')">School</th>
                  <th v-if="visibleColumns.includes('Opting')">Opting</th>
                  <th width="90">More actions</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr v-for="(item, index) in contacts_data.data" :key="index" class="table-row"
                  :class="{ opted_out: item.optedOut }">
                  <td class="opt_blur" :class="{ active: item.active }">
                    <div class="row">
                      <input v-model="item.checked" @change="checkItem(item)" class="checkbox" type="checkbox" />
                      <div class="h-spacer"></div>
                      <widgetProfile :title="item.first_name + ' ' + item.last_name"
                        :subtitle="processLocation(item.location)" file_name="" path="" @click="viewContact(item)">
                      </widgetProfile>
                    </div>
                  </td>

                  <td v-if="visibleColumns.includes('Account')" class="phone-hide opt_blur">
                    <div @click="
                      $router.push({
                        name: 'account-view',
                        params: { type: 'overview', id: item.account.id },
                      })
                      " class="contact-account">
                      <widgetProfile :title="item.account.name" subtitle="" file_name="" path="" :size="19"
                        :text_size="9">
                      </widgetProfile>
                    </div>
                  </td>
                  <td v-if="visibleColumns.includes('Email_Phone')" @click="viewContact(item)"
                    class="phone-hide opt_blur">
                    <div class="email">
                      {{ item.email | validate }}
                    </div>
                    <div class="phone">
                      {{ item.phone_alt | validate }}
                    </div>
                  </td>
                  <td v-if="visibleColumns.includes('Position_Domain')" @click="viewContact(item)"
                    class="phone-hide opt_blur">
                    <div class="email">
                      {{ item.position | validate }}
                    </div>
                    <div class="phone">
                      {{ item.domain | validate }}
                    </div>
                  </td>
                  <td v-if="visibleColumns.includes('ContactOwner')" class="phone-hide opt_blur"
                    @click="viewContact(item)">
                    <div class="applied-owners row" v-if="item.owners">
                      <div v-for="(inter, ind) in item.owners" :key="ind" v-if="ind < 4" class="applied-owner row">
                        <widgetProfile :title="inter.first_name + ' ' + inter.last_name" subtitle=""
                          :showContent="item.owners.length == 1" file_name="" :size="19" :text_size="9" path="">
                        </widgetProfile>
                      </div>
                      <div v-if="item.owners.length > 4" class="applied-internship row">
                        and More
                      </div>
                    </div>
                  </td>

                  <td v-if="visibleColumns.includes('Tags')" class="opt_blur">
                    <widgetTagsViewer :tags="item.tags" @remove="(e) => {
                      removeContactTags(item.id, e.id, e.i, item.tags);
                    }
                    "></widgetTagsViewer>
                  </td>
                  <td v-if="visibleColumns.includes('ContactTypes')" class="opt_blur">
                    <widgetTagsViewer :tags="item.roles"></widgetTagsViewer>
                  </td>
                  <td v-if="visibleColumns.includes('School')" class="phone-hide opt_blur">
                    <widgetTagsViewer :tags="item.schools" :canDelete="false"></widgetTagsViewer>
                  </td>
                  <td v-if="visibleColumns.includes('Opting')" class="opt_blur">
                    <div class="opted-out opt_blur" v-if="item.optedOut">
                      Opt-out
                    </div>
                  </td>
                  <td>
                    <div class="menu">
                      <dropdownMenu>
                        <ul>
                          <li v-if="item.optedOut">
                            <a @click="optContact(item, 'in')">Set as Opt-in</a>
                          </li>
                          <li v-else>
                            <a @click="optContact(item, 'out')">Set as Opt-out</a>
                          </li>
                          <li>
                            <a @click="updateContact(item)">Edit</a>
                          </li>
                          <li>
                            <app-dialog title="Delete Contact" ask="Are you sure you want to delete this contact?"
                              yesText="Delete" noText="Cancel" @onComfirm="deleteContact(item.id)">
                              <a>Delete Contact</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdownMenu>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Loading widget -->
            <div class="content-loading-container" v-if="contact_loading">
              <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="contact_loading"
                :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
            </div>

          </div>
          <!-- Grid View -->
          <div class="contact-grid-widget" @scroll="onPageScoll" v-else>
            <div class="contacts-items" v-if="contacts_data && contacts_data.data.length > 0">
              <div class="contact-item" v-for="(item, index) in contacts_data.data" :key="index"
                @click="viewContact(item)" :class="{ active: item.active }">
                <img src="@/assets/contact-avatar.svg" />
                <div class="contact-details-info">
                  <h3>
                    {{ (item.first_name + " " + item.last_name) | validate }}
                  </h3>
                  <h5 v-if="false">{{ item.title | validate }}</h5>
                  <p class="email">{{ item.email | validate }}</p>
                  <p class="phone">{{ item.phone_alt | validate }}</p>
                </div>
                <dropdown-menu class="menu">
                  <ul>
                    <li>
                      <a @click.prevent="updateContact(item)" href>Edit Contact</a>
                    </li>
                    <li>
                      <app-dialog title="Delete Contact" ask="Are you sure you want to delete this contact?"
                        yesText="Delete" noText="Cancel" @onComfirm="deleteContact(item.id)">
                        <a>Delete Contact</a>
                      </app-dialog>
                    </li>
                  </ul>
                </dropdown-menu>
              </div>
            </div>
            <!-- Loading widget -->
            <div class="content-loading-container" v-if="contact_loading">
              <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="contact_loading"
                :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
            </div>
          </div>

          <!-- Not found -->
          <div v-if="contacts_data &&
            contacts_data.data.length == 0 &&
            !contact_loading
          " class="not-found">
            <widgetNotFoundWidget title="No Contact Found" content="Looks like you haven't added any contact yet"
              btntext="Add new contact" @click="addNew()">
              <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
            </widgetNotFoundWidget>
          </div>
        </div>


      </div>
    </div>

    <!-- Add - Update Modal -->
    <addUpdateContactModal v-if="show_form_add_update" :content="selected_contact" acccountType="account_contact"
      @success="contactSaved" @close="show_form_add_update = false"></addUpdateContactModal>

    <!-- Send Mail -->
    <sendMailModal v-if="show_send_mail_modal" :content="selected_contacts" type="contact" @success="sendEmailSuccess()"
      @close="show_send_mail_modal = false"></sendMailModal>

    <!-- Add LIA -->
    <addInternshipModal v-if="show_add_internship_modal" :content="null" type="gen"
      :account_data="accounts_for_internship" @success="show_add_internship_modal = false"
      @close="show_add_internship_modal = false"></addInternshipModal>

    <!-- Contact Details -->
    <contactDetailsModal v-if="show_contact_details_modal" :contact_id="contact_id"
      @close="show_contact_details_modal = false" @update="updateContact" @delete="deleteContact"></contactDetailsModal>

    <!-- Add Contact Owner on Multi -->
    <addContactOwnerOnMiltModal v-if="show_add_contact_owner_modal" :selectedContactIds="selected_contacts"
      @success="onAddContactOwnerSuccess" @close="show_add_contact_owner_modal = false">
    </addContactOwnerOnMiltModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import sendMailModal from "@/views/Accounts/components/send_mail_modal.vue";
import addUpdateContactModal from "@/views/Accounts/components/add_update_contact_modal.vue";
import addInternshipModal from "@/views/internship/components/add_internship_modal.vue";
import internshipItem from "@/views/internship/components/internship_item.vue";
import contactDetailsModal from "@/views/Accounts/components/contact_details_modal.vue";
import addContactOwnerOnMiltModal from "@/views/Accounts/components/add_contact_owner_on_milt_modal.vue";
export default {
  components: {
    sendMailModal,
    addUpdateContactModal,
    addInternshipModal,
    internshipItem,
    contactDetailsModal,
    addContactOwnerOnMiltModal,
  },
  props: {
    filter: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data: () => ({
    show_filter_widget: false,
    show_add_internship_modal: false,
    accounts_for_internship: null,
    selected_contact: null,
    show_send_mail_modal: false,
    selected_contacts: [],
    selected_list_dropdown: false,
    sort_input_filter: false,
    tags_input_filter: false,
    roles_input_filter: false,
    display_input_filter: false,
    data_input_filter: false,
    tab: 2,
    view_type: "list",
    sort_filter_data: "",
    display_filter: [
      {
        value: "grid",
        name: "Grid",
      },
      {
        value: "list",
        name: "List",
      },
    ],
    tag_filter_data: "",
    tags_filter: [],
    roles_filter: [],
    sort_filter: [
      {
        value: "create_date",
        name: "Create Date",
      },
      {
        value: "name",
        name: "Name",
      },
    ],
    data_filter: [
      {
        value: "mine",
        name: "My Contacts",
      },
      {
        value: "all",
        name: "All Contacts",
      },
    ],
    show_form_add_update: false,
    show_view_contant_modal: false,
    contacts_data: null,
    show_selected_options: false,
    filter_form: {
      type: "all",
      contact_type: "account_contact",
      location: "",
      url_type: "",
      query: "",
      tags: [],
      contact_owner: [],
      roles: [],
      sort_field: "name",
      sort_type: "asc",
      next_page_url: "",
    },
    contact_loading: false,
    isAllContactSelected: false,
    show_contact_details_modal: false,
    contact_id: null,
    stickContactCard: false,
    contact_owner_input: false,
    contact_owner_filter: [],
    show_add_contact_owner_modal: false,
    view_input: false,
    visibleColumns: ['Account', 'Email_Phone', 'Position_Domain', 'ContactOwner', 'Tags', 'ContactTypes', 'School', 'Opting'], // Default visible columns
    availableColumns: [
      { key: 'Account', label: 'Account' },
      { key: 'Email_Phone', label: 'Email & Phone' },
      { key: 'Position_Domain', label: 'Position & Domain' },
      { key: 'ContactOwner', label: 'Contact Owner' },
      { key: 'Tags', label: 'Tags' },
      { key: 'ContactTypes', label: 'Contact Types' },
      { key: 'School', label: 'School' },
      { key: 'Opting', label: 'Opting' },
    ],
    initialLoaded: false,
  }),
  mounted() {
    let vm = this;
    if (vm.filter) {
      vm.filter_form = vm.filter;
    }
    vm.getContactsData("init");
    if (vm.$route.params.id) {
      vm.contact_id = vm.$route.params.id;
      vm.show_contact_details_modal = true;
    }
  },
  computed: {
    isActiveFilter: function () {
      let vm = this;
      return (
        vm.filter_form.type == "mine" ||
        vm.filter_form.query ||
        vm.filter_form.tags.length > 0 ||
        vm.filter_form.contact_owner.length > 0 ||
        vm.filter_form.roles.length > 0 ||
        vm.filter_form.sort_field != "name" ||
        vm.filter_form.sort_type != "asc" ||
        vm.filter_form.location
      );
    },
  },
  methods: {
    setTableColumns(data) {
      let vm = this;
      vm.visibleColumns = data;
    },
    onAddContactOwnerSuccess() {
      let vm = this;
      vm.show_add_contact_owner_modal = false;
      vm.getContactsData("init");
    },
    addContactOwnerOnSelected() {
      let vm = this;
      vm.selected_contacts = vm.validateChecked("data").map(item => item.id);
      vm.show_add_contact_owner_modal = true;
    },
    processLocation(locations) {
      let vm = this;
      let full_location = "";
      if (locations && Array.isArray(locations)) {
        locations.forEach((location, index) => {
          full_location += index == 0 ? location : ", " + location;
        });
      }
      return full_location;
    },
    onPageDetailsScoll(e) {
      let vm = this;
      if (e.target.scrollTop > 150) {
        vm.stickContactCard = true;
      } else {
        vm.stickContactCard = false;
      }
    },
    onFilterByLocation(data) {
      let vm = this;
      if (data.name) {
        vm.filter_form.location = data.name;
        vm.getContactsData("init");
      } else {
        vm.filter_form.location = "";
        vm.getContactsData("init");
      }
    },
    removeContactTags(contact_id, id, index, tags) {
      let vm = this;
      vm.$store
        .dispatch("CONTACT_DELETE_TAG", {
          id: id,
          contact_id: contact_id,
        })
        .then((response) => {
          tags.splice(index, 1);
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Tag removed",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    addInternship() {
      let vm = this;
      eventBus.$emit("openDialogMessage", {
        title: "Generate LIA",
        message: "We'd like to let you know that not all contacts can create LIAs. Just the LIA contacts are able to create LIA. As a result, the total number of internships may differ from the total number of contacts on your list.",
        action_label: "Proceed",
        callback: () => {
          let payload = {
            type: "many",
            origin: "contact",
            contacts: vm.validateChecked("data"),
            allSelected: vm.isAllContactSelected
          };
          vm.accounts_for_internship = payload;
          vm.show_add_internship_modal = true;
        },
        action_close_label: "Cancel",
      });

    },
    onPageScoll({ target }) {
      let vm = this;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 100) {
        if (
          !vm.contact_loading &&
          vm.contacts_data.current_page < vm.contacts_data.last_page
        ) {
          vm.getContactsData("next");
        }
      }
    },
    sendEmailSuccess() {
      let vm = this;
      vm.show_send_mail_modal = false;
    },
    sendEmailSelectedAccount() {
      let vm = this;
      vm.selected_contacts = vm.validateChecked("data");
      if (vm.selected_contacts.length == 1) {
        if (vm.selected_contacts[0].optedOut) {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Selected contact opted out",
            type: "warn",
            duration: 3000,
          });
          return;
        }
      }
      vm.show_send_mail_modal = true;
    },
    ExportSelectedContact() {
      let vm = this;
      let ids = vm.validateChecked("data");
      vm.$store
        .dispatch("ACCOUNT_CONTACT_EXPORT", {
          ids: ids.map((item) => item.id),
          all: vm.isAllContactSelected,
          filters: vm.filter_form,
          columns: vm.visibleColumns
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "contact.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    onSelectAll({ target }) {
      let vm = this;
      vm.isAllContactSelected = target.checked;
      if (target.checked) {
        vm.contacts_data.data = vm.contacts_data.data.map((item) => {
          eventBus.$set(item, "checked", true);
          return item;
        });
      } else {
        vm.contacts_data.data = vm.contacts_data.data.map((item) => {
          eventBus.$set(item, "checked", false);
          return item;
        });
      }
      vm.validateChecked();
    },
    checkItem(item) {
      let vm = this;
      vm.validateChecked();
    },
    validateChecked(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_options =
          vm.contacts_data.data
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      return vm.contacts_data.data
        .filter((item) => item.checked == true)
        .map((item) => item);
    },
    selectTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    getContactsTags() {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_GET_TAGS")
        .then((response) => {
          vm.tags_filter = response.data.map((item) => {
            return {
              value: item.name,
              name: item.name,
              checked: vm.filter_form.tags.includes(item.name)
            };
          });
        })
        .catch((error) => { });
    },
    getContactsRoles() {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_GET_ROLES")
        .then((response) => {
          vm.roles_filter = response.data.map((item) => {
            return {
              value: item.name,
              name: item.name,
              checked: vm.filter_form.roles.includes(item.name)
            };
          });
        })
        .catch((error) => { });
    },
    getContactOwners() {
      let vm = this;
      vm.$store.dispatch("ACCOUNT_GET_CONTACT_OWNERS").then((response) => {
        vm.contact_owner_filter = response.data.map((item) => {
          return {
            value: `${item.first_name ? item.first_name : ""} ${item.last_name ? item.last_name : ""}`,
            name: `${item.first_name ? item.first_name : ""} ${item.last_name ? item.last_name : ""}`,
            checked: vm.filter_form.contact_owner.includes(item.id),
          };
        });
      });
    },

    // Filter functions
    clearFilter() {
      let vm = this;
      vm.filter_form.query = "";
      vm.filter_form.tags = [];
      vm.filter_form.contact_owner = [];
      vm.filter_form.roles = [];
      vm.filter_form.sort_field = "name";
      vm.filter_form.sort_type = "asc";
      vm.filter_form.next_page_url = "";
      vm.filter_form.location = "";
      vm.filter_form.type = "all";
      vm.getContactsData("init");
    },
    filterBySort(field, type) {
      let vm = this;
      vm.filter_form.sort_field = field;
      vm.filter_form.sort_type = type;
      vm.sort_input = false;
      vm.getContactsData("init");
    },
    filterByTag(tags) {
      let vm = this;
      vm.filter_form.tags = tags;
      vm.getContactsData("init");
    },
    filterByContactOwner(data) {
      let vm = this;
      vm.filter_form.contact_owner = data;
      vm.getContactsData("init");
    },
    filterByRole(roles) {
      let vm = this;
      vm.filter_form.roles = roles;
      vm.getContactsData("init");
    },
    searchContacts({ target }) {
      let vm = this;
      vm.filter_form.query = target.value;
      vm.getContactsData("init");
    },
    filterContactByType(type) {
      let vm = this;
      vm.filter_form.type = type;
      vm.data_input_filter = false;
      vm.getContactsData("init");
    },
    // ====
    optContact(item, status) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_CONTACT_OPTING", {
          contact_id: item.id,
          status: status,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text:
              status == "out"
                ? "Contact was opted out"
                : "Contact opted in successfully",
            type: "success",
            duration: 3000,
          });
          if (status == "out") {
            item.optedOut = true;
          } else {
            item.optedOut = false;
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    deleteContact(id) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_CONTACT_DELETE", { contact_id: id })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Contact deleted successfully",
            type: "success",
            duration: 3000,
          });
          vm.show_contact_details_modal = false;
          vm.contact_id = null;
          vm.getContactsData("init");
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    DeleteSelectedContacts() {
      let vm = this;
      let ids = vm.validateChecked("data");
      vm.$store
        .dispatch("ACCOUNT_CONTACT_DELETE_SELECTED", {
          ids: ids.map((item) => item.id),
          all: vm.isAllContactSelected,
          filters: vm.filter_form,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Contact deleted successfully",
            type: "success",
            duration: 3000,
          });
          vm.contact_id = null;
          vm.show_contact_details_modal = false;
          vm.getContactsData("init");
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    viewContact(item) {
      let vm = this;
      vm.$router.push({
        name: "accounts",
        params: { type: "account_contacts", id: item.id },
      });
      vm.contacts_data.data.forEach((item) => {
        item.active = false;
      });
      eventBus.$set(item, "active", true);
      vm.getContantDetails(item.id);
    },
    getContantDetails(id) {
      let vm = this;
      vm.contact_id = id;
      vm.show_contact_details_modal = true;
    },
    addNew() {
      let vm = this;

      vm.selected_contact = null;
      vm.show_form_add_update = true;
    },
    contactSaved(data) {
      let vm = this;
      vm.getContantDetails(data.id);
      vm.selected_contact = null;
      vm.show_form_add_update = false;
      vm.getContactsData("init");
    },
    updateContact(item) {
      let vm = this;
      vm.selected_contact = item;
      vm.show_contact_details_modal = false;
      vm.show_form_add_update = true;
    },
    getContactsData(type = "init") {
      let vm = this;
      vm.contact_loading = true;
      if (type == "init") {
        vm.contacts_data = null;
      }
      vm.filter_form.url_type = type;
      vm.filter_form.next_page_url = vm.contacts_data
        ? vm.contacts_data.next_page_url
        : "";
      vm.$store
        .dispatch("ACCOUNT_CONTACT_GET_DATA", vm.filter_form)
        .then((responce) => {
          vm.contact_loading = false;
          if (!vm.initialLoaded) {
            Promise.all([
              vm.getContactsTags(),
              vm.getContactsRoles(),
              vm.getContactOwners()
            ]).catch(error => {
              console.error('Error loading initial data:', error);
            });
            vm.initialLoaded = true;
          }
          responce.data.data = responce.data.data.map((item, index) => {
            if (vm.isAllContactSelected) {
              eventBus.$set(item, "checked", true);
            } else {
              eventBus.$set(item, "checked", false);
            }
            eventBus.$set(item, "active", false);
            eventBus.$set(item, "expand_student", false);
            if (index == 0 && type == "init") {
              eventBus.$set(item, "expanded", true);
            } else {
              eventBus.$set(item, "expanded", false);
            }
            if (typeof item.schools === 'string') {
              eventBus.$set(item, "schools", JSON.parse(item.schools));
            } else if (item.schools == null) {
              eventBus.$set(item, "schools", []);
            }
            return item;
          });

          if (type == "init") {
            vm.contacts_data = responce.data;
            if (vm.contacts_data.current_page < vm.contacts_data.last_page) {
              vm.getContactsData("next");
            }
          } else {
            vm.contacts_data.next_page_url = responce.data.next_page_url;
            vm.contacts_data.current_page = responce.data.current_page;
            vm.contacts_data.last_page = responce.data.last_page;
            responce.data.data.forEach((item) => {
              vm.contacts_data.data.push(item);
            });
          }
        })
        .catch((error) => {
          vm.contact_loading = false;
          console.error({ error });
        });
    },
  },
  watch: {
    filter_form: {
      handler: function (val) {
        let vm = this;
        vm.$emit('onFilter', val)
      },
      deep: true,
    },
    "$route.params.id": function (id) {
      let vm = this;
      vm.getContantDetails(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;

    .options {
      display: flex;
      align-items: center;

      .search-account {
        width: 250px;
      }

      .btn-add {
        margin-left: 20px;
      }

      .filter-item {
        border: 1px solid #ddd;
        border-radius: 5px;
        height: 30px;
        display: flex;
        align-items: center;
        padding: 0 10px;
      }
    }
  }

  .page-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    margin-bottom: 5px;

    .selected-dropdown {
      position: relative;
    }
  }

  .page-body {
    height: calc(100% - 80px);

    .phone-hide {
      @media (min-width: 300px) and (max-width: 630px) {
        display: none;
      }
    }

    .tab-body {
      height: calc(100% - 47px);
      width: 100%;
      overflow-y: unset;
      height: 100%;
      position: relative;
      padding: 0px;
      display: flex;
      justify-content: space-between;

      .left-panel {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        transition: all 0.3s ease-in-out;
        position: relative;
        background: #fff;
        border-radius: 5px;
        padding: 5px;

        &.reduce {
          width: calc(100% - 410px);
          transition: all 0.3s ease-in-out;
        }

        .contacts-table {
          height: 100%;
          overflow-y: auto;
          min-width: calc(100% - 400px);
          width: 100%;

          .table-data {
            border-collapse: collapse;
            border-spacing: 0;

            .opted_out {
              // background: #efefef;

              .opt_blur {
                // opacity: 0.3;
              }
            }

            tr {
              .table-row {
                border-bottom: 1px solid rgb(207, 207, 207);
              }

              &:hover {
                background: rgb(248, 248, 248);
                cursor: pointer;
              }

              th {
                text-align: left;

                .center {
                  width: 100%;
                  display: flex;
                  justify-content: center;
                }
              }

              td {
                text-align: left;
                font-size: 13px;
                color: rgb(28, 28, 28);

                .end {
                  float: right;
                }

                .account-name {
                  color: #0884af;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 150px;
                }

                .contact-account {
                  padding: 2px;
                  background: #f7f7f7;
                  border-radius: 5px;
                  width: max-content;
                }

                .email {
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 100px;
                }

                .phone {
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 100px;
                }

                .opted-out {
                  color: #ffffff;
                  background: #a51b1b;
                  border-radius: 5px;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  padding: 4px 10px;
                }

                .count-internship {
                  background: #f6f6f6;
                  border-radius: 5px;
                  width: 24px;
                  height: 24px;
                  font-family: "Nunito";
                  font-style: normal;
                  font-weight: 400;
                  font-size: 11px;
                  line-height: 22px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #000000;
                }


                .menu {
                  width: 100%;
                  display: flex;
                  justify-content: center;
                }

                .applied-owners {
                  background: #f7f7f7;
                  border-radius: 5px;
                  padding: 2px;
                  margin: 3px 10px;
                }

                &:first-child {
                  border-top-left-radius: 5px;
                  border-bottom-left-radius: 5px;
                }

                &:last-child {
                  border-top-right-radius: 5px;
                  border-bottom-right-radius: 5px;
                }
              }
            }
          }
        }

        .contact-grid-widget {
          display: flex;
          flex-direction: column;
          height: 100%;
          overflow-y: auto;
          min-width: calc(100% - 400px);
          width: 100%;
          background: #fff;
          border-radius: 10px;

          .contacts-items {
            width: 100%;
            display: grid;
            padding: 10px;
            grid-template-columns: calc(33% - 5px) calc(33% - 5px) calc(33% - 5px);
            grid-gap: 10px;

            .contact-item {
              position: relative;
              background: #eeeeee;
              border-radius: 6px;
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 15px;
              max-height: 250px;
              cursor: pointer;

              &.active {
                background: #f8f8f8;
                border: none;
              }

              img {
                width: 80px;
                margin-bottom: 7px;
              }

              .contact-details-info {
                display: flex;
                flex-direction: column;
                align-items: center;

                h3 {
                  margin: 0px;
                  font-size: 18px;
                  margin-bottom: 4px;
                }

                h5 {
                  margin: 0px;
                  font-size: 15px;
                  color: #646262;
                  margin-bottom: 10px;
                }

                p {
                  margin: 0px;
                  font-size: 13px;
                  color: #646262;
                }
              }

              .menu {
                position: absolute;
                top: 8px;
                right: 10px;
              }
            }
          }
        }

        .not-found {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 100%;
          font-size: 20px;
          background: #fff;
          border-radius: 10px;
        }
      }


    }
  }
}

.form-widget-modal {
  width: 600px;

  .moder-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-option {
      display: flex;
      align-items: center;

      input {
        margin-right: 5px;
      }

      label {
        margin-top: 5px;
      }
    }
  }

  .modal-body {
    .form-widget {
      .form-widget-header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        input[type="radio"] {
          position: relative;
          top: -3px;
          left: -5px;
          margin-right: 8px;
        }

        img {
          margin-left: 5px;
        }

        label {
          cursor: pointer;
        }
      }

      .form-widget-body {
        .template-widget {
          margin-bottom: 30px;

          .btn-download {
            width: 200px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: flex !important;
            justify-content: center;
            align-items: center;
          }
        }

        .upload-widget {
          display: flex;
          align-items: center;

          .uploader {
            width: 200px;

            .btn-upload {
              width: 200px;
              height: 45px;
              background: #1890a9 0% 0% no-repeat padding-box;
              border-radius: 4px;
              color: #fff;
              outline: none;
              margin-right: 20px;
              display: flex !important;
              justify-content: center;
              align-items: center;

              img {
                margin-left: 6px;
                width: 20px;
                position: relative;
                top: -1px;
              }
            }
          }

          .selected-file {
            display: flex;
            align-items: center;

            img {
              position: relative;
              top: 3px;
            }
          }
        }
      }
    }

    .line {
      border-bottom: 1px solid #ddd;
      margin: 10px 0px;
    }
  }
}

.search-account-item {
  padding: 10px 15px;
  display: block;
  cursor: pointer;

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-account-item {
  padding: 5px 12px;
  display: block;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
